import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { getProductInfo } from "../../redux/reducer/product.reducer.js";

import ProductDetail from "./components/product.detail.jsx";
import ProductBasic from "./components/product.basic.jsx";

export default function Product() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { productInfo } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(
      getProductInfo({
        id: id,
      })
    );
  }, []);

  return (
    <article className="product">
      <ProductBasic product={productInfo} />
      <ProductDetail product={productInfo} />
    </article>
  );
}
